<template>
  <div>
    <v-alert 
      color="warning" 
      icon="priority_high" 
      value="true">
      {{ error }}
    </v-alert>
  </div>
</template>

<script>
// const debug = require('debug')('OD::Error')

export default {
  name: 'Error',
  props: {
    error: {
      type: String,
      required: true,
    },
  }
}
</script>

<style>
</style>
